import cardHover from './hover';

const baseCardShared = {
  cursor: 'pointer'
};

const baseCard = {
  interactive: {
    ...baseCardShared,
    ...cardHover.baseHover,
    boxShadow: 'cardList'
  },
  raised: {
    ...baseCardShared,
    boxShadow: 'cardList'
  }
};

const pressCard = {
  interactive: {
    ...baseCardShared,
    ...cardHover.pressHover
  },
  raised: {
    ...baseCardShared,
    boxShadow: 10
  }
};

const card = {
  products: {
    chart: baseCard,
    chartblog: baseCard,
    co: baseCard,
    edu: baseCard,
    press: pressCard,
    spark: baseCard
  }
};

export const cardVariants = ['interactive', 'raised'];

export default card;
